import React from 'react';
import { NavLink } from 'react-router-dom';
import { Icon } from '@fikasio/react-ui-components';
import { useTranslation } from 'react-i18next';
import { ADMIN_MENU_WIDTH, MAIN_SIDEBAR_WIDTH, TOP_BAR_HEIGHT } from 'components/UI/layout';
import { AdminSection } from 'components/admin/sections';
import styles from './AdminSidebar.module.css';

const AdminSidebar = ({
  sections,
}: {
  sections: readonly AdminSection[];
}) => {
  const { t } = useTranslation();

  return (
    <nav
      aria-label={t('admin')}
      className={styles.sidebar}
      style={{
        '--admin-left': `${MAIN_SIDEBAR_WIDTH}px`,
        '--admin-top': `${TOP_BAR_HEIGHT}px`,
        '--admin-width': `${ADMIN_MENU_WIDTH}px`,
      } as React.CSSProperties}
    >
      <div className={styles.title}>{t('admin')}</div>
      <ul className={styles.list}>
        {
          sections.map(section => (
            <li key={section.id}>
              <NavLink
                className={({ isActive }) => (
                  [styles.link, isActive ? styles.active : ''].filter(Boolean).join(' ')
                )}
                end
                to={section.path}
              >
                <Icon
                  name={section.icon}
                  size="1x"
                />
                {t(section.labelKey)}
              </NavLink>
            </li>
          ))
        }
      </ul>
    </nav>
  );
};

export default AdminSidebar;
